import ChartfieldList from 'Components/Generic/ChargeAllocations/ChartfieldList';
import EditableDetailPanel from 'Components/Generic/DetailPanel/EditableDetailPanel';
import PropTypes from 'prop-types';
import { useState } from 'react';

const ChartfieldSetupPanel = ({
  transaction,
  lineItems,
  editable = false,
  disabled = false,
  isNew = false,
  ...props
}) => {
  const [editState, setEditState] = useState(undefined);
  return (
    <EditableDetailPanel
      title={editable ? 'Charge Allocation Setup' : 'Charge Allocations'}
      editable={editable}
      parentEditState={isNew || editState}
      disabled={disabled}
      hideToggle={isNew}
      renderChild={(inEditState) => {
        return (
          <ChartfieldList
            transaction={transaction}
            lineItems={lineItems}
            setEditState={setEditState}
            editable={inEditState}
            isNew={isNew}
            {...props}
          />
        );
      }}
    />
  );
};

ChartfieldSetupPanel.propTypes = {
  transaction: PropTypes.object,
  lineItems: PropTypes.array,
  editable: PropTypes.bool,
  disabled: PropTypes.bool,
  isNew: PropTypes.bool,
};

export default ChartfieldSetupPanel;
